<template>
  <div class="admin-organizations-page container">
    <breadcrumbs
      :breadcrumb-links="[{url:adminHomeURL, text: 'Admin home'},{text: 'Organizations'}]"
    />
    <div class="row">
      <div class="col-12 card">
        <h2>Organizations</h2>
        <p>You can enable or disable organizations here, or modify an organization's users by clicking on that organizations name.</p>
        <organization-table :sort-list-by="`organization`" :is-sort-desc="false" />
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationTable from '../../components/Admin/OrganizationTable';
import metadata from '../../util/metadata';
import routeNames from '../../util/routeNames';
import Breadcrumbs from '../../components/Breadcrumbs';

export default {
  name: 'AdminOrganizations',
  components: { OrganizationTable, Breadcrumbs },
  data() {
    return {
      adminHomeURL: routeNames.ADMIN.PATH
    }
  },
  metaInfo: {
    title: `Organizations | Admin | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [
      { name: 'description', content: 'Administration dashboard for managing organizations for The Salvation Army' }
    ]
  },
}
</script>
